<template>
    <div class="d-flex align-items-end">
        <pc-input
            v-if="editorExposed"
            v-bind:key="`${inputId}-edit-revealed`"
            v-model="newValue"
            type="text"
            class="flex-grow-1"
            v-bind:label="newValueLabel" />
        <pc-input
            v-else
            v-bind:key="`${inputId}-edit-hidden`"
            v-model="newValue"
            type="password"
            autocomplete="new-password"
            class="flex-grow-1"
            v-bind:label="newValueLabel" />
        <pc-button
            class="ms-2"
            v-on:click="onShowNewValue">
            {{ editorExposed ? hideButtonLabel : showButtonLabel }}
        </pc-button>
    </div>
</template>
<script>
    import { KEYS, NAMESPACE } from "./i18n/editSensitiveValueDialog.i18n";
    import { mapI18n } from "Util/i18n";

    export const RESULT_HOOK = "getDialogResult";
    export const DIALOG_RESULT = {
        ok: "OK",
        cancel: "CANCEL"
    };

    export default {
        props: {
            inputId: { type: String, required: true }
        },
        data() {
            return {
                newValue: "",
                editorExposed: false
            };
        },
        computed: {
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        },
        methods: {
            onShowNewValue() {
                this.editorExposed = !this.editorExposed;
            },
            [RESULT_HOOK](result) {
                if (result === DIALOG_RESULT.cancel) {
                    return null;
                }

                return this.newValue;
            }
        }
    };
</script>
